module.exports = __webpack_public_path__ + "img/hr-pipe-corner-up-right.34f0f7a3.png";